function handleElementSelection(event) {
    var target = event.target;
    var label = target.nextElementSibling;
  
    if (target.tagName === 'INPUT' || target.tagName === 'LABEL') {
      var radios = document.querySelectorAll('input[name="' + target.name + '"]');
  
      radios.forEach(function(radio) {
        var radioLabel = radio.nextElementSibling;
        if (radio === target) {
          radioLabel.classList.add('selected');
        } else {
          radioLabel.classList.remove('selected');
        }
      });
    }
  }